<template>
  <div class="absolute-bottom-right q-pa-xl">
    <q-icon name="fas fa-cogs" size="200px" color="blue-grey-1" />
    <span class="text-bold text-h1 text-blue-grey-1 vertical-bottom q-ml-lg">系统设置 </span>
  </div>
</template>